import React from 'react';

import { BuildPath } from '../../../helpers/Paths';
import { UserUploadStage } from '../../../models/ApiResponseModels/UserUploadHistoryResponseModel'

const TableStatus = ({status, pendingRequestStatus}:{status: UserUploadStage, pendingRequestStatus: boolean}) => {
    let imgProps: {alt: string, src: string, className: string};
    
    switch(status) {
        case UserUploadStage.Completed:
            imgProps = {alt: 'Complete', src: `${BuildPath()}/images/userupload/completed.svg`, className: 'upload-status-icon'};
            break;

        case UserUploadStage.Failed:
            imgProps = {alt: 'Failed with Errors', src: `${BuildPath()}/images/userupload/failedwitherrors.svg`, className: 'upload-status-icon'};
            break;

        case UserUploadStage.Cancelled:
            imgProps = {alt: 'Cancelled', src: `${BuildPath()}/images/userupload/failedwitherrors.svg`, className: 'upload-status-icon'};
            break;

        case UserUploadStage.Errored:
            imgProps = {alt: 'Errored', src: `${BuildPath()}/images/userupload/failedwitherrors.svg`, className: 'upload-status-icon'};
            break;

        case UserUploadStage.Comparing:
            imgProps = {
                alt: pendingRequestStatus ? 'In Progress' : `Awaiting Action`,
                src: `${BuildPath()}/images/userupload/rolling.svg`,
                className:'upload-status-processing'};
            break
        case UserUploadStage.Completing:
            imgProps = {
                alt:  `Completing`,
                src: `${BuildPath()}/images/userupload/rolling.svg`,
                className:'upload-status-processing'};
            break
        case UserUploadStage.Cancelling:
            imgProps = {
                alt: 'Cancelling',
                src: `${BuildPath()}/images/userupload/rolling.svg`,
                className:'upload-status-processing'};
            break
        case UserUploadStage.Uploaded:
        case UserUploadStage.Validating:
        case UserUploadStage.ReadyForImport:
            imgProps = {alt: 'In Progress', src: `${BuildPath()}/images/userupload/rolling.svg`, className:'upload-status-processing'};
            break;
        default:
            imgProps = null; 
    }
    
    return (
        imgProps
        ?<>  
            <img {...imgProps} />
            {imgProps.alt}
        </>
        :null
    )
}
export default TableStatus;